import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";

const InsuranceSimulationErrorsModal = ({
  show,
  onHide,
  errors,
  type,
  onAction,
}) => {
  const { _t } = useTranslator();
  const isPropertyError = type === "property";
  const title = isPropertyError
    ? _t("missingPropertyDetails")
    : _t("pleaseAddMissingDetailsForInsurance");
  const description = isPropertyError
    ? _t("fillFollowingFieldsInPropertySettingsToContinue")
    : "";
  const actionLabel = _t("goToPropertySettings");

  return (
    <Modal
      className="wrapper-modal insurance-simulation-errors-modal"
      show={show}
      onHide={onHide}
      centered
      style={{ zIndex: 1053 }}
    >
      <Modal.Header>
        <Modal.Title>
          <div className="cursor-pointer" onClick={onHide}>
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center justify-content-center rounded-circle error-icon-bg">
              <img src="/images/red-error.svg" alt="Error" />
            </div>
            <div className="d-flex flex-column align-items-start error-modal-title-wrapper">
              <h5 className="mb-0 error-modal-title">{title}</h5>
              <p>Required before awarding insurance.</p>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="property-errors-main-container mb-2">
          {description && (
            <p className="property-errors-description">{description}</p>
          )}
          <ul
            className={isPropertyError ? "property-errors-list-plain" : ""}
            style={{ fontSize: "14px" }}
          >
            {errors.map((error, index) => (
              <li
                className={
                  isPropertyError ? "" : "d-flex align-items-center gap-6px"
                }
                key={index}
              >
                {!isPropertyError && (
                  <img src="/images/red-error.svg" alt="Error" />
                )}
                <span>{error}</span>
              </li>
            ))}
          </ul>
        </div>
        {isPropertyError && (
          <div className="d-flex align-items-center justify-content-center custom-gap-2 mt-4">
            <button
              type="button"
              className="commonButtonPropertyDark commonButtonPropertyLight"
              onClick={onHide}
            >
              {_t("cancel")}
            </button>
            <button
              type="button"
              className="btnNext commonButtonPropertyDark"
              onClick={onAction}
            >
              {actionLabel}
            </button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default InsuranceSimulationErrorsModal;
